__turbopack_context__.v({
  "breakoutContainer": "PBFDHW_breakoutContainer",
  "centered": "PBFDHW_centered",
  "clickable": "PBFDHW_clickable",
  "container": "PBFDHW_container",
  "image": "PBFDHW_image",
  "medium": "PBFDHW_medium",
  "noMarginBottom": "PBFDHW_noMarginBottom",
  "small": "PBFDHW_small",
});
